<div class="sidebar-outer">
    <a class="logo d-flex align-items-center" routerLink="/" (click)="closeSubMenus()" *ngIf="settings.theme.sidebarIsFixed">
      <span class="start"><b>Credence Admin Control Panel</b></span><span class="ng"></span>
    </a>
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>    
</div>
